export default class DynamicTabs {
  constructor() {
    this.dynamicTabs = document.querySelector(".jsDynamicTabs");

    if (this.dynamicTabs) {
      this.dynamicTabsHead = this.dynamicTabs.querySelectorAll(".jsDynamicTabsHead");
      this.dynamicTabsItem = this.dynamicTabs.querySelectorAll(".jsDynamicTabsItem");

      this.init();
    }
  }

  setAsCurrent(arr, id) {
    for (let i = 0; i < arr.length; i++) {
      const el = arr[i];

      parseInt(el.dataset.id) === id ? el.classList.add("active") : el.classList.remove("active");
    }
  }

  changeTab(id) {
    this.setAsCurrent(this.dynamicTabsHead, id);
    this.setAsCurrent(this.dynamicTabsItem, id);
  }

  init() {
    for (let i = 0; i < this.dynamicTabsHead.length; i++) {
      const el = this.dynamicTabsHead[i];

      el.addEventListener("click", () => {
        this.changeTab(parseInt(el.dataset.id));
      });
    }
  }
}
